import { render, staticRenderFns } from "./ShippingCompanyAccounts.vue?vue&type=template&id=254408b6&"
import script from "./ShippingCompanyAccounts.vue?vue&type=script&lang=ts&"
export * from "./ShippingCompanyAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports